module.exports = __webpack_public_path__ + "static/media/ic_home_inactive.83b29d15.svg";